import React from 'react';
import {FSFNotAvailableLightBoxStore} from '../../_flux/stores/fsf_not_available_light_box_store';
import {FSFNotAvailableLightBox} from '../../_flux/components/fsf_not_available_light_box/fsf_not_available_light_box';
import {hideAction} from '../../_flux/actions/fsf_not_available_light_box_actions';
import {handleView} from '../handle_view';

const stores = {
    state: FSFNotAvailableLightBoxStore
};

const render = ({state}, options) => (
    <FSFNotAvailableLightBox
        visible={state.visible}
        onClose={hideAction}
        productType={options.productType}
    />
);

export const init = (container, options) =>
    handleView(stores, render, options, container);
